import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import { Button } from '@lion-design/core';
import LoadingSpinner from '@components/Common/LoadingSpinner';
import {
    setContactTelOpen,
    setAbroadDepOpen,
    setNextStepLoading,
} from '@Redux/detail/Group/actions';

interface NextStepBtnProps {
    typeClass?: string;
    statusText: string;
    disabledBtn: boolean;
    comingSoon: boolean;
}

const NextStepBtn: React.FC<NextStepBtnProps> = (props) => {
    const { typeClass, statusText, disabledBtn, comingSoon } = props;
    const { GroupInfo } = useSelector((store: RootState) => store.groupReducer);
    const { nextStepLoading } = useSelector((store: RootState) => store.switcherReducer);
    const dispatch = useDispatch();

    return (
        <Button
            className={`btn-primary ${typeClass ?? ''}`}
            {...(disabledBtn || comingSoon
                ? { disabled: true }
                : { href: GroupInfo.Country !== 'TW' ? '' : GroupInfo.StatusUrl })}
            onClick={() => {
                GroupInfo.Status == 4 && dispatch(setContactTelOpen(true));
                GroupInfo.Country !== 'TW' && dispatch(setAbroadDepOpen(true));
                dispatch(setNextStepLoading(true));
            }}
        >
            {statusText}
            <LoadingSpinner showLoad={nextStepLoading} />
        </Button>
    );
};

export default NextStepBtn;
